import React from 'react'
import CONSTANTS from "../../../../utils/constants";
import { Button, ButtonGroup } from "@material-ui/core";
import { useStyles } from "./style";
import { useLocation, useNavigate } from "react-router-dom";

const {
  FDM_DASHBOARD: {
    TAB_CONFIGS: { ALL_COMPANIES, PORTFOLIO, WATCHLIST },
  },
} = CONSTANTS;

const ListTabs = () => {
  const styles = useStyles();

  const navigate = useNavigate();
  const { search } = useLocation();
  const activeTab = new URLSearchParams(search).get("tab") ?? PORTFOLIO.value;

  const tabInfo = [
    {
      label: PORTFOLIO.label,
      value: PORTFOLIO.value,
      isActive: activeTab === PORTFOLIO.value,
      testId: "portfolio-btn",
    },
    {
      label: WATCHLIST.label,
      value: WATCHLIST.value,
      isActive: activeTab === WATCHLIST.value,
      testId: "watchlist-btn",
    },
    {
      label: ALL_COMPANIES.label,
      value: ALL_COMPANIES.value,
      isActive: activeTab === ALL_COMPANIES.value,
      testId: "all-companies-btn",
    },
  ];

  const handleFilterClick = (filterValue: string) => {
    navigate(`?tab=${filterValue}`);
  };

  return (
    <ButtonGroup variant="outlined">
      {tabInfo.map((btn) => (
        <Button
          key={btn.testId}
          variant={btn.isActive ? "contained" : "outlined"}
          color="primary"
          className={styles.button}
          onClick={() => handleFilterClick(btn.value)}
          data-testid={btn.testId}
        >
          {btn.label}
        </Button>
      ))}
    </ButtonGroup>
  );
};

export default ListTabs;
